// src/util/admin_api_util.js
import axios from 'axios';

// ===== ADMIN SUMMARY ===== //

// Overall dashboard stats (students + masters)
// Backend: GET /api/admin/summary
export const fetchAdminSummary = () => {
  return axios.get('/api/admin/summary');
};

// ===== PENDING STUDENTS ===== //

// List all pending student applicants
// Backend: GET /api/admin/students/pending
export const fetchPendingStudents = () => {
  return axios.get('/api/admin/students/pending');
};

// Approve a student and enroll them in courses
// data = {
//   studentId,
//   courseKeys: ["ombre_powder_brows", ...],
//   scheduleByCourseKey?: {
//     [courseKey]: { startDate: string|Date, modelTimeSlot?: string }
//   }
// }
// Backend: POST /api/admin/students/approve-and-enroll
export const approveStudentAndEnroll = (data) => {
  return axios.post('/api/admin/students/approve-and-enroll', data);
};

// Remove a pending student (reject)
// Backend: DELETE /api/admin/students/:studentId
export const deletePendingStudent = (studentId) => {
  return axios.delete(`/api/admin/students/${studentId}`);
};

// ===== PENDING MASTERS ===== //

// List all pending master applicants
// Backend: GET /api/admin/masters/pending
export const fetchPendingMasters = () => {
  return axios.get('/api/admin/masters/pending');
};

// ===== ACTIVE STUDENTS / MASTERS ===== //

// Approved + enrolled students (any approved student)
// Backend: GET /api/admin/students/active
export const fetchActiveStudents = () => {
  return axios.get('/api/admin/students/active');
};

// Approved masters
// Backend: GET /api/admin/masters/active
export const fetchActiveMasters = () => {
  return axios.get('/api/admin/masters/active');
};

// =========================
// USER COURSE ASSIGNMENT (students + masters)
// Canonical in Mongo:
//   - students:  coursesEnrolled: [courseKey]
//   - masters:   teachingCourses: [courseKey]
// Backend: /api/admin/users/:userId/courses/:courseKey
// =========================

// Assign a user (student or master) to a courseKey
export const assignUserToCourse = (userId, courseKey) => {
  return axios.post(`/api/admin/users/${userId}/courses/${courseKey}`);
};

// Remove a course from a user (student or master)
export const removeUserFromCourse = (userId, courseKey) => {
  return axios.delete(`/api/admin/users/${userId}/courses/${courseKey}`);
};

// =========================
// MASTER APPROVAL
// =========================

// Approve a master (or any user) using your existing users route:
//   PATCH /api/users/approve/:id
// This route is JWT-protected and checks role === "grandmaster" or "master"
export const approveMaster = (masterId) => {
  return axios.patch(`/api/users/approve/${masterId}`);
};
